// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"report-screen_pageHeading__eXMHw","pageHeadingTitle":"report-screen_pageHeadingTitle__3d1hr"};